<template>
    <div>
    <!-- rules属性传入约定的验证规则，并将form-item中的prop属性设置为需校验的字段名即可 -->
     <el-form :model="form" :rules="rules" ref="ruleForm" class="login-box">
        <h3 class="login-title">欢迎登录</h3>
        <el-form-item label="用户名" prop="name">
            <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="密  码" prop="pwd">
            <el-input placeholder="请输入密码" v-model="form.pwd" show-password></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
    </el-form>
    </div>
</template>

<script>
import { getHomePageDatakvnum } from "@/services/getdata";

    export default{
        name:'Login',
        data(){
            return {
                form:{
                    name:'',
                    pwd:'',
                }, 
                ticket:'11',
                rules: {
                    name: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ],
                    pwd:[
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
                    ]
                    }
               };
              },
            methods:{
                submitForm(ruleForm){
               //     this.$router.push({path:'/main'});
                    this.$refs[ruleForm].validate((valid) => {
                        if (valid) {
                            // this.$router.push("/index")
                            sessionStorage.setItem('isLogin',true);
                            this.$router.push({path:'/main'})
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                resetForm(ruleForm){
                    this.$refs[ruleForm].resetFields();
                }
            },
            created(){
                const splitUrl = window.location.href.split("?");
                console.log("splitUrl[]",splitUrl);
                if(splitUrl.length>1){
                    console.log("splitUrl",splitUrl[1]);
                    const searchParams = {}
                    // 如果 location 中有 search 值 ，去除 search 值中的第一个字符 ‘?’
                        const searchStr = splitUrl[1]
                    // 以 & 符为分隔符，解析出 key value 组合 ，组合的形式为 'key=value'
                        const searchArr = searchStr.length ? searchStr.split('&') : []
                    
                        searchArr.forEach(item => {
                    // 以 = 为分隔符，解析出 key 和 value , 其中数组的第一项为 key ，数组的第二项为 value
                        let keyAndValue = item.split('=')
                    // 如果查询参数中包含中文，会被编码成一串字符串，需要使用 decodeURIComponent 进行 解码
                        let key = decodeURIComponent(keyAndValue[0])
                        let value = decodeURIComponent(keyAndValue[1])
                        if (key) {
                            searchParams[key] = value
                        }
                        })
                
                    
                    this.ticket=searchParams["ticket"];
                    
                }
                let param={
                    "ticket":this.ticket
                }
                this.submitForm(param);
            }
    }


</script>
<style scoped>
    .login-box{
        width: 350px;
        margin:150px auto;
        border:1px solid #DCDFE6;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0px 0px 30px #797c85;
    }
    .login-title{
        text-align: center;
    }
</style>